import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App.js'
import './tokens.css'

/*
 * The customer portal shares the company's address with the app, and a phone
 * offers to install whatever page links a manifest. A customer reading a
 * proposal is not somebody to offer the office's app to, so the portal unlinks
 * it before anything is drawn; nothing navigates from the portal to the app.
 */
if (window.location.pathname === '/portal' || window.location.pathname.startsWith('/portal/')) {
  document.querySelector('link[rel="manifest"]')?.remove()
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
